import { createContext, type ReactNode, useContext } from "react";

const Enabled = createContext(false);
const Features = createContext<readonly string[] | null>(null);

/** Original verified shell licence; presentation only, server admission still applies. */
export function AiLicenseProvider({
  enabled,
  features = null,
  children,
}: {
  readonly enabled: boolean;
  /** Null is a legacy embedding; [] explicitly advertises no configured feature. */
  readonly features?: readonly string[] | null;
  readonly children: ReactNode;
}) {
  return (
    <Enabled.Provider value={enabled}>
      <Features.Provider value={features}>{children}</Features.Provider>
    </Enabled.Provider>
  );
}

export function useAiLicence() {
  return useContext(Enabled);
}

/** A courtesy from the verified session; record admission remains on the server. */
export function useAiFeature(name: string): boolean | null {
  const features = useContext(Features);
  return features === null ? null : features.includes(name);
}
